module.exports = __webpack_public_path__ + "static/media/embroidery-stitch-diagram.a7176696.JPG";